import geoData from '@tfx/common/mixins/geoData'
import {useInlineTemplateCompiler} from '@tfx/common/hooks/use-inline-template-compiler'

export default {
  name: 'country-guide',

  mixins: [geoData],

  setup() {
    useInlineTemplateCompiler()
  },

  watch: {
    countryGuide() {
      this.$nextTick(this.setGeoLinkUrl)
    }
  },

  mounted() {
    this.setGeoLinkUrl()
  },

  methods: {
    setGeoLinkUrl() {
      Array.from(this.$el.querySelectorAll('.country-guide-geo-link')).forEach((el) => el.href = this.geoGuide)
    }
  }
}
